<div class="main">
    <div class="images">
        <!-- <img class="panda1" src="../../assets/images/panda.png" > -->
        <div class="imgtop"></div>

        <div class="whatwedopage">
            <div class="whatwedoimg">
                <div class="title2">
                    What do we do?
                </div>
                <div class="infowhatwedo">
                    We are an interactive platform dedicated to spreading awareness and management about mental health.
                </div>
            </div>
        </div>

        <!-- <div class = "randomimg"></div> -->
    </div>
    <div class="maincont">
        <div class="toptrans">
            <div class="content">
                <div class="name">
                    CHI
                </div>
                <div class="tagline">
                    A safe space for mental health
                </div>
                <!-- <div class = "custbutton">
                    Shop now
                </div> -->
            </div>
        </div>
        <div class="infosec">
            <div class="name2">
                Why is mental health and awareness important?
            </div>
            <div class="info">
                Mental health includes our <span style="color: var(--lpink)">emotional, psychological, and social
                    well-being.</span>It affects
                <span style="color: var(--dpink)">how we think, </span> <span style="color: var(--lpink)">feel,
                </span><span style="color: var(--dpink)">and act.</span>It
                also helps determine
                <span style="color: var(--dpink)">how we handle stress, relate to
                    others, and make healthy choices. </span> Mental health is <span style="color: var(--dpink)">
                    important at every stage of life, from childhood and adolescence
                    through adulthood.</span>
                To make the world more <span style="color: var(--dpink)">aware and safe</span>, mental
                health and awareness are <span style="color: var(--lpink)">highly important.</span>




            </div>
        </div>
        <div class="whatwedo">

        </div>
        <div class="spaces">
            <div class="name2">
                Explore our spaces
            </div>

            <div class="spacespace">
                <div class = "space" *ngFor = "let x of spaces; let i = index" routerLink={{x.link}}>
                    <div class = "spaceimg"><img src = {{x.image}} style="height: 100%; width: 100%;"></div>
                    <div class = "namespace">{{x.name}}</div>
                </div>
            </div>

        </div>
    </div>

</div>